// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import axios from 'axios' //axios
import VueAxios from 'vue-axios'

import VideoPlayer from 'vue-video-player'
Vue.use(VideoPlayer)

import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
Vue.use(VueDirectiveImagePreviewer) 

Vue.use(VueAxios,axios)
Vue.prototype.$axios = axios    //全局注册，使用方法为:this.$axios

// 按需引入vant组件
import {
  List,
  Popup
} from 'vant';
// 使用vant组件
Vue.use(List)
Vue.use(Popup)

Vue.config.productionTip = false


window.poi = {};

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers.post['Access-Control-Allow-Credentials'] = true;

//拦截器
axios.interceptors.response.use(function (response) {
  return response.data;
}, function (error) {
  console.log(error.response)
  if (!error.response || error.response.status == 403) {
    localStorage.removeItem('tou')
    return location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe7168543b03805a6&redirect_uri=' + encodeURIComponent(window.location.href) + '&response_type=code&scope=snsapi_userinfo&state=state#wechat_redirect'
  }

  // if(error.response.status == 403) return location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx792c0a2341386c9e&redirect_uri=' + encodeURIComponent(window.location.href) + '&response_type=code&scope=snsapi_userinfo&state=state#wechat_redirect'
  return Promise.reject(error);
});


// 获取链接字段
function getUrlParam (url, name) {
  var reg = new RegExp('(\\?|&)' + name + '=([^&]+)');
  var r = url.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return false;
};

//挂载
function goo (data) {
  new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
  })
}


//获取config
axios.get('/static/config.json')
  .then((response) => {
    poi.config = response;
    axios.defaults.headers.post['Access-Control-Allow-Origin'] = response.api_host.one;
    axios.defaults.baseURL = response.api_host.one;
  })
  .then(()=> {
    var code = getUrlParam(window.location.href,'code')
    var tou = JSON.parse(localStorage.getItem("tou"));
    //判断跳转
    if (!code && !tou) {
      window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe7168543b03805a6&redirect_uri=' + encodeURIComponent(window.location.href) + '&response_type=code&scope=snsapi_userinfo&state=state#wechat_redirect'
    } else if (!tou && code) {
      var url = '/onlogin'
      axios({
        method:'post',
        url:url,
        data:JSON.stringify({    //这里是发送给后台的数据
          'code': code,
        }),
      }).then((res) =>{          //ES6
        console.log(res)       //请求成功返回的数据
        axios.defaults.headers.common['Authorization'] = res.data.Authorization
        // history.replaceState(null,null,'/');  //移除code
        localStorage.setItem('tou',JSON.stringify(res));
        goo ()
      }).catch((error) =>{
          console.log(error)       //请求失败返回的数据
      })
    } else {
      console.log(tou)
      axios.defaults.headers.common['Authorization'] = tou.data.Authorization
      goo ()
    }
  })



// WEBPACK FOOTER //
// ./src/main.js